import React from "react";
import styled from "styled-components";
import { Grid } from "@mui/material";
import ShowWithSkeleton from "src/utils/show-with-skeleton";
import UpskillingChart from "src/components/upskilling-chart";
import UpskillingMetrics from "src/components/upskilling-metrics";

const UpskillingTitle = styled.h3`
    font-size: 13px;
    font-weight: 300;
    text-align: center;
`;

const Upskilling = ({ fetchAction }) => {
    return (
        <Grid container spacing={2}>
            <Grid item md={3} mb={1}>
                <ShowWithSkeleton
                    fetchAction={fetchAction}
                    height="100%"
                    width="95%"
                    streamingProperty={
                        fetchAction.data &&
                        fetchAction.data.upskilling &&
                        fetchAction.data.upskilling.usage &&
                        fetchAction.data.upskilling.usage.expected
                    }
                >
                    <UpskillingTitle>Expected Languages</UpskillingTitle>
                    <UpskillingMetrics
                        data={
                            fetchAction.data &&
                            fetchAction.data.upskilling &&
                            fetchAction.data.upskilling.usage &&
                            fetchAction.data.upskilling.usage.expected
                        }
                        variant="expected"
                    />
                </ShowWithSkeleton>
            </Grid>
            <Grid item md={6} mt={1.5}>
                <ShowWithSkeleton
                    fetchAction={fetchAction}
                    height="100%"
                    width="95%"
                    streamingProperty={fetchAction.data && fetchAction.data.upskilling}
                >
                    <UpskillingChart data={fetchAction.data && fetchAction.data.upskilling} />
                </ShowWithSkeleton>
            </Grid>
            <Grid item md={3} mb={1}>
                <ShowWithSkeleton
                    fetchAction={fetchAction}
                    height="100%"
                    width="95%"
                    streamingProperty={fetchAction.data && fetchAction.data.upskilling}
                >
                    <UpskillingTitle>New Languages</UpskillingTitle>
                    <UpskillingMetrics
                        data={
                            fetchAction.data &&
                            fetchAction.data.upskilling &&
                            fetchAction.data.upskilling.usage &&
                            fetchAction.data.upskilling.usage.new
                        }
                        variant="new"
                    />
                </ShowWithSkeleton>
            </Grid>
        </Grid>
    );
};

export default Upskilling;
